import { IAppState } from '../../common/state';

export function selectSellersInfoModal(state: IAppState) {
  return state.sellersInfoModal;
}
